export const ESG_REPORT_SECTION_GROUPS = [
  {
    id: "general",
    sections: [
      "general-exec-summary",
      "general-waste-metrics",
      "general-utility-metrics",
      "general-scope-emissions",
      "general-monitoring-metrics",
      "general-social-training",
      "general-branches",
      "general-methodology",
    ],
  },
  {
    id: "waste",
    sections: [
      "waste-exec-summary",
      "waste-handled",
      "waste-composition",
      "waste-diverted-recycled",
      "waste-branch-table",
      "waste-unassigned",
      "waste-disposal-disclaimer",
      "waste-gri306-coverage",
      "waste-methodology",
    ],
  },
  {
    id: "carbon",
    sections: [
      "carbon-exec-summary",
      "carbon-breakdowns",
      "carbon-audit",
      "carbon-methodology",
    ],
  },
] as const;

export type EsgReportCustomizeGroupId =
  (typeof ESG_REPORT_SECTION_GROUPS)[number]["id"];

export type EsgReportSectionId =
  (typeof ESG_REPORT_SECTION_GROUPS)[number]["sections"][number];

export const ALL_ESG_REPORT_SECTIONS: EsgReportSectionId[] =
  ESG_REPORT_SECTION_GROUPS.flatMap((group) => [...group.sections]);

export function getDefaultEsgReportSections(): EsgReportSectionId[] {
  return [...ALL_ESG_REPORT_SECTIONS];
}

export function sanitizeEsgReportSections(selected: unknown): EsgReportSectionId[] {
  const allowed = new Set<string>(ALL_ESG_REPORT_SECTIONS);
  if (!Array.isArray(selected)) return getDefaultEsgReportSections();
  const sanitized = selected.filter(
    (id): id is EsgReportSectionId => typeof id === "string" && allowed.has(id),
  );
  if (selected.length === 0) return [];
  return sanitized.length > 0 ? sanitized : getDefaultEsgReportSections();
}

export function isEsgReportSectionEnabled(
  id: EsgReportSectionId,
  includeSections?: readonly EsgReportSectionId[] | null,
): boolean {
  if (!includeSections) return true;
  return includeSections.includes(id);
}
